<div class="drilldown-toggle-chart-legend-container" *ngIf="legends.length">
  <ng-container *ngFor="let legendItem of legends; let i = index">
    <span class="drilldown-toggle-chart-legend-circle" [style.background]="legendItem.color"></span>
    <span class="drilldown-toggle-chart-legend-label">{{ adjustText(legendItem.text) }}</span>
  </ng-container>
</div>
